// src/components/BlogEntry.jsx
import React from 'react';
import { PRIMARY_FONT } from '../constants';
import ReactMarkdown from 'react-markdown';

const BlogEntry = ({ entry, isExpanded, toggleExpand }) => {
  return (
    <div className="max-w-96 mx-auto notebook-card p-6 page-fold">
      <div className="flex items-center mb-2">
        {entry.tags.map(tag => (
          <span
            key={tag}
            className="font-handwritten text-xs text-white text-opacity-30 border border-white border-opacity-10 px-2 py-1 rounded-sm mr-2"
          >
            {tag}
          </span>
        ))}
      </div>
      <h3
        className="font-handwritten text-2xl font-bold mb-2 tracking-tight"
        style={{ fontFamily: PRIMARY_FONT }}
      >
        {entry.title}
      </h3>
      <div className="font-handwritten text-xl text-white text-opacity-60 mb-4">
        <ReactMarkdown>{entry.content}</ReactMarkdown>
      </div>
      {entry.spotify && (
        <div className="mb-4">
          <iframe
            title={`${entry.title} - Spotify`}
            style={{ borderRadius: '2px', border: '1px solid rgba(255,255,255,0.06)' }}
            src={entry.spotify}
            width="100%"
            height="152"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      )}
      <button
        onClick={toggleExpand}
        className="font-handwritten text-sm text-white text-opacity-30 border border-white border-opacity-10 px-3 py-1 rounded-sm hover:text-opacity-60 transition duration-300"
      >
        {isExpanded ? 'See less' : 'See more'}
      </button>
      {isExpanded && (
        <div className="mt-4">
          <p className="font-handwritten text-sm text-white text-opacity-40">date: {entry.date}</p>
        </div>
      )}
    </div>
  );
};

export default BlogEntry;
